export default __webpack_public_path__ + "static/media/display-picture.5143046e.svg";